import { Text } from '@chakra-ui/react';
import { MdChevronRight } from 'react-icons/md';

export function PageBreadcrumb({ items }: { items: string[] }) {
  return (
    <Text color="gray.500" mb={2} display="inline-flex" alignItems="center">
      {items.map((item, i) => (
        <span key={i} style={{ display: 'inline-flex', alignItems: 'center' }}>
          {i > 0 && <MdChevronRight size="20px" color="#8b8b8b" style={{ margin: '0 8px' }} />}<b>{item}</b>
        </span>
      ))}
    </Text>
  );
}